import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Container } from './style';
import { MembershipTypesRowHeader } from '../../../Components/Rows/MembershipPlanRow/Header';
import { Row } from '../../../Layouts';
import { SearchInput, AddButton } from '../../Members/style';
import { Loading } from '../../WithLoading/Loading';
import { EmptyState } from '../../WithEmptyState/EmptyState';
import { MembershipTypesEmptyState } from '../../../Components/BannerEmptyStats/BannerEmptyStats';
import { MembershipPlanRow } from '../../../Components/Rows/MembershipPlanRow';
import { Text } from '../../../UI/Text';
import { MembersActionCreators } from '../../../../Store/ActionCreators/MembersActionCreators';
import { MembershipPlansActionCreators } from '../../../../Store/ActionCreators/MembershipPlansActionCreators';

class MembershipTypes extends Component {
    state = {
        searchQuery: '',
        daysWindowOpenId: null,
        expiryWindowOpenId: null,
        classLimitWindowOpenId: null,
        classesWindowOpenId: null,
        usageLimitWindowOpenId: null,
        regularityWindowOpenId: null,
    };

    componentDidMount() {
        this.props.getMembershipPlans();
    }

    handleChange = ({ target: { value } }) => {
        this.setState({ searchQuery: value });
    };

    addPlan = () => {
        const planData = {
            name: 'Untitled plan',
            deadline_date: null,
            deadline_days: null,
            credits: null,
            auto_renew: false,
            price: 1,
            signup_fee: 1,
            regularity: 1,
            payments_count: 1,
        };

        this.props.addMembershipPlan(planData);
    };

    closeAllWindows = () => {
        this.setState({
            daysWindowOpenId: null,
            expiryWindowOpenId: null,
            classLimitWindowOpenId: null,
            classesWindowOpenId: null,
            usageLimitWindowOpenId: null,
            regularityWindowOpenId: null,
        });
    };

    toggleActions = {
        toggleDaysWindow: id => {
            let daysWindowOpenId = this.state.daysWindowOpenId === id ? null : id;

            this.setState({
                daysWindowOpenId,
                expiryWindowOpenId: null,
                classLimitWindowOpenId: null,
                classesWindowOpenId: null,
                usageLimitWindowOpenId: null,
                regularityWindowOpenId: null,
            });
        },

        toggleExpiryWindow: id => {
            let expiryWindowOpenId = this.state.expiryWindowOpenId === id ? null : id;

            this.setState({
                expiryWindowOpenId,
                daysWindowOpenId: null,
                classLimitWindowOpenId: null,
                classesWindowOpenId: null,
                usageLimitWindowOpenId: null,
                regularityWindowOpenId: null,
            });
        },

        toggleClassLimitWindow: id => {
            let classLimitWindowOpenId = this.state.classLimitWindowOpenId === id ? null : id;

            this.setState({
                classLimitWindowOpenId,
                daysWindowOpenId: null,
                expiryWindowOpenId: null,
                classesWindowOpenId: null,
                usageLimitWindowOpenId: null,
                regularityWindowOpenId: null,
            });
        },

        toggleClassesWindow: id => {
            let classesWindowOpenId = this.state.classesWindowOpenId === id ? null : id;

            this.setState({
                classesWindowOpenId,
                daysWindowOpenId: null,
                expiryWindowOpenId: null,
                classLimitWindowOpenId: null,
                usageLimitWindowOpenId: null,
                regularityWindowOpenId: null,
            });

            this.props.getClassesForPlans();
        },

        toggleUsageLimitWindow: id => {
            let usageLimitWindowOpenId = this.state.usageLimitWindowOpenId === id ? null : id;

            this.setState({
                usageLimitWindowOpenId,
                classesWindowOpenId: null,
                daysWindowOpenId: null,
                expiryWindowOpenId: null,
                usageLimitWindowOpenId: null,
                regularityWindowOpenId: null,
            });
        },

        toggleRegularityWindow: id => {
            const regularityWindowOpenId = this.state.regularityWindowOpenId === id ? null : id;

            this.setState({
                regularityWindowOpenId,
                usageLimitWindowOpenId: null,
                classesWindowOpenId: null,
                daysWindowOpenId: null,
                expiryWindowOpenId: null,
                usageLimitWindowOpenId: null,
            });
        },
    };

    rowApiActions = {
        updatePlan: (id, planData) => {
            this.props.updateMembershipPlan(id, planData);
        },

        deletePlan: id => {
            this.props.deleteMembershipPlan(id);
        },
    };

    render() {
        const {
            state: { searchQuery, ...state },
            props: { arePlansLoading, plans, classesForPlans, classesForPlansLoading, assignClassesToPlan },
            handleChange,
            rowApiActions,
            toggleActions,
            addPlan,
        } = this;
        const filteredPlans = plans.filter(plan => plan.name.includes(searchQuery));
        const isEmpty = filteredPlans.length === 0;

        return (
            <Container>
                <Row justify={'space-between'}>
                    <SearchInput placeholder={'Search membership types'} value={searchQuery} onChange={handleChange} />

                    <Row>
                        <Text weight={100} opacity={0.75} fontSize={12} marginRight={'15px'}>
                            Changes made will be instantly saved
                        </Text>
                        <AddButton onClick={addPlan}>Add</AddButton>
                    </Row>
                </Row>

                <div
                    style={{ width: '100%', height: 'calc(100vh - 50px)', overflowX: 'scroll', paddingBottom: '20px' }}
                >
                    <Loading isLoading={arePlansLoading}>
                        <EmptyState isEmpty={isEmpty} emptyState={MembershipTypesEmptyState}>
                            <MembershipTypesRowHeader />
                            {filteredPlans.map((plan, index) => (
                                <MembershipPlanRow
                                    assignClassesToPlan={assignClassesToPlan}
                                    classesLoading={classesForPlansLoading}
                                    classesForPlans={classesForPlans}
                                    onCloseAll={this.closeAllWindows}
                                    {...rowApiActions}
                                    {...toggleActions}
                                    {...state}
                                    {...plan}
                                    key={index}
                                />
                            ))}
                        </EmptyState>
                    </Loading>
                </div>
            </Container>
        );
    }
}

const mapStateToProps = ({
    membershipPlans: {
        statuses: { arePlansLoading },
        plans,
    },
    members: {
        statuses: { classesForPlansLoading },
        classesForPlans,
    },
}) => ({
    arePlansLoading,
    plans,
    classesForPlansLoading,
    classesForPlans,
});

const mapDispatchToProps = dispatch => ({
    getMembershipPlans: () => dispatch(MembershipPlansActionCreators.getMembershipPlansRequest()),
    addMembershipPlan: planData => dispatch(MembershipPlansActionCreators.addMembershipPlanRequest(planData)),
    updateMembershipPlan: (id, planData) =>
        dispatch(MembershipPlansActionCreators.updateMembershipPlanRequest(id, planData)),
    deleteMembershipPlan: id => dispatch(MembershipPlansActionCreators.deleteMembershipPlanRequest(id)),
    getClassesForPlans: () => dispatch(MembersActionCreators.getClassesForPlansRequest()),
    assignClassesToPlan: (planId, seriesIds) =>
        dispatch(MembersActionCreators.assignClassesForPlansRequest(planId, seriesIds)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MembershipTypes);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/MembershipTypes/index.js